import React, { Component } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { fetchAccountStats } from '../../redux/actions/steemAccountActions';
import { withRouter } from 'react-router-dom'
import {withTranslation} from "react-i18next";
import OwnedDomainsTable from './components/DomainsTable';
import DomainSearchbar from './components/SearchForDomains';

class DomainsPage extends Component {

    render() {

        const { t } = this.props;

        return (
            <Container className="dashboard">
                <Row>
                    <Col md={12}>
                        <h3 className="page-title">{t('domains.title')}</h3>
                    </Col>
                </Row>
                <Row>
                    <OwnedDomainsTable domains={this.props.domains} />
                </Row>
                <Row>
                    <DomainSearchbar />
                </Row>
            </Container>)
    }

}


const mapStateToProps = (state) => {
    return {
        domains: state.domains
    }
}

const mapsDispatchToProps = (dispatch) => {
    return {
        onFetchAccountStats: (username) => dispatch(fetchAccountStats(username))
    }
}

export default withRouter(connect(mapStateToProps, mapsDispatchToProps)(withTranslation('dashboard')(DomainsPage)));
